import { AuthProvider, UserProvider } from '@myosh/myosh-login'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router'
import App from './App'
import Notifications from './components/UI/notifications/Notifications'
import Meta from './features/meta/meta'
import './i18n'
import './index.css'
import store from './redux/store'

const container = document.getElementById('root')
const root = createRoot(container as HTMLElement)

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <AuthProvider>
            <UserProvider>
              <Meta />
              <App />
              <Notifications />
            </UserProvider>
          </AuthProvider>
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
)
